import WRODetailsSection from "./WRODetailsSection";
export default WRODetailsSection;
